import { render, staticRenderFns } from "./ProgressPercentage.vue?vue&type=template&id=220ca15c"
import script from "./ProgressPercentage.vue?vue&type=script&lang=js"
export * from "./ProgressPercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports